import type { TextareaHTMLAttributes } from 'react'
import { cls } from './cls'
import { FIELD_BASE } from './field'

/** A multi-line text control. */
export function Textarea({ className, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      className={cls(FIELD_BASE, 'w-full min-h-[80px] py-2.5 resize-y', className)}
      {...rest}
    />
  )
}
